import type { Kpi } from '@netpurpose/types'
import type { AxiosInstances } from '../../client'
import { SimpleAbstractModelApi } from '../SimpleAbstractModelApi'
import { formatKpi, reverseKpiFieldMap } from './formatKpi'
import { type BackendKpi, parseKpi } from './parseKpi'

export class KpiApi extends SimpleAbstractModelApi<BackendKpi, Kpi> {
  endpoint = '/kpis/'
  modelFormatter = formatKpi
  reverseFieldMap = reverseKpiFieldMap

  constructor(axiosInstances: AxiosInstances) {
    super(axiosInstances, parseKpi)
  }
}
